import { useEffect, useRef, useState } from 'react';
import { ItfCouponCountdownDate } from './type';
import { useGlobalTimestamp } from '@/utils/useGlobalTimestamp';
import { formatCountdown } from 'eco-design-micro/utils/formatCountdown';
import './index.scss';
import useEcoCart from '../../useEcoCart';
import getLocal from 'eco-design-reliance/getLocal';
import { i18n } from '../../i18n';

const EcoCartCountdown: React.FC = () => {
    const { locale = '' } = getLocal();
    const t = i18n?.[locale] || i18n.en;
    const { coupon } = useEcoCart();
    const globalTimestamp = useGlobalTimestamp();
    const [countdownDateObj, setCountdownDateObj] = useState({ d: '00', h: '00', m: '00', s: '00' } as ItfCouponCountdownDate);
    const deltaTimestamp = globalTimestamp > 0 ? globalTimestamp - Date.now() : 0;
    const timer = useRef<NodeJS.Timeout | null>(null);

    const getServerTimeNow = () => Date.now() + deltaTimestamp;
    const clearTimer = () => {
        if (timer.current) {
            clearInterval(timer.current);
            timer.current = null;
        }
    };

    const init = () => {
        if (coupon) {
            const [startTime, endTime] = [
                new Date(`${coupon.startTime.replaceAll('-', '/')} GMT+8`).getTime(),
                new Date(`${coupon.endTime.replaceAll('-', '/')} GMT+8`).getTime(),
            ];
            const serverTime = getServerTimeNow();
            if (startTime < endTime && startTime <= serverTime && serverTime < endTime) {
                setCountdownDateObj(formatCountdown(endTime - serverTime) as ItfCouponCountdownDate);
            } else {
                clearTimer();
            }
        }
    };

    useEffect(() => {
        if (coupon && coupon.startTime && coupon.endTime) {
            init();
            clearTimer();
            timer.current = setInterval(() => {
                init();
            }, 1000);
        }
        return () => clearTimer();
    }, [coupon, globalTimestamp]);

    return (
        <>
            {coupon && (
                <div className={`eco-cart-coupon-countdown ${coupon.ruleType}`}>
                    <span className="eco-cart-coupon-countdown-text">{t.cart_coupon_countdown}</span>
                    <div className="eco-cart-coupon-countdown-time">
                        <span className="day date-number">{countdownDateObj.d}</span>
                        <span className="hour date-number">{countdownDateObj.h}</span>
                        <span className="minute date-number">{countdownDateObj.m}</span>
                        <span className="second date-number">{countdownDateObj.s}</span>
                    </div>
                </div>
            )}
        </>
    );
};

export default EcoCartCountdown;
